import axios from "axios";
import * as React from "react";
import { FC, useState, useEffect, useRef } from 'react';
import AudioPlayer, { RHAP_UI } from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import { useHistory } from "react-router-dom";
import { Loading } from "./Loading";

export const AudioPodcast = ({passPortal, user})=> {    
    const history = useHistory();
    const {campaign, surveyAnsw, search, token, ap, DeviceID, survey_ids, threshold, userData, skip_seconds, 
        skip_podcast, each_seconds,  portal_label_access, portal_label_return, portal_show_timer, start_counter, forward_audio_podcast }: any = history.location.campaign ? history.location : history.location.state;
    let interval: any = null;
    const [playing, setPlaying] = useState({
        id: 0,
        play: false,
        src_audio: ""
    });
    const [firstPlay, setFirstPlay] = useState(false);
    const [audioList, setAudioList] = useState([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [counter, setCounter] = useState<number>(skip_podcast);
    const [playList, setPlayList] = useState([]);
    const [analyticsAudio, setAnalyticsAudio] = useState<{
        podcast_id: number,
        duration: number,
        deviceid: string,
        ap_mac: string,
        date_play: Date
    }[]>([]);
    let conunterLocal = skip_podcast;
    

    useEffect(() => {
        getPodcasts();
        if(start_counter) {
            initiCounter();
        }
        return () => {
            clearInterval(interval);
         };
    }, []);



    const initiCounter = () => {
        interval = setInterval(() => {
            conunterLocal = conunterLocal - 1;
            //console.log("eyou")
            if (conunterLocal === 0) {
                clearInterval(interval);
                return;
            }

            setCounter(conunterLocal);
        }, 1000);

    }

    const getPodcasts = async () => {
        try {
            setLoading(true);
            //console.log(campaign);
            const res = await axios.get("/podcast", { 
                params: {
                    campaign_id: campaign.CampaignID
                }
            });
            //console.log(res.data);
            if(res.data.ok) {
                setAudioList(res.data.podcast);
            }
            setLoading(false);
        } catch (error) {
            console.log(error);
        }
    }

    const _goBack = () => {
        //_postImpression(false);
        postAnalyticsPodcast();
        if(search) {
          history.replace(`/${search}`)
        }else {
          history.goBack();
        }
    }

    const _postImpression = async () => {
        try {
          setLoading(true);
          const fields = {
            AccessPointID: ap.ap_mac,
            LocationID: Number(ap.ap_locationid),
            DeviceID,
            CampaignID: campaign.CampaignID,
            MediaType: "podcast"
          };
          await axios.post("/impressions", { fields });
          //await postBalance(campaign, type);
          postAnalyticsPodcast();
          passPortal(ap, campaign, DeviceID);
          setLoading(false);

        } catch (err) {
          console.log(err);
          setLoading(false);
        }
    }

    const postPlayAudio = async (audio) => {
        try {
            const fields = {
                ...audio,
                plays: Number(audio.plays) + 1,
            }
            await axios.post("/playaudio", { fields });
        } catch (error) {
            console.log(error);
        }
    }

    const postAnalyticsPodcast = async () => {
        try {
            if(analyticsAudio.length) {
                const fields = {
                    analyticsAudio
                }
                const re = await axios.post("/analyticspodcast", { fields });
            }
        } catch (error) {
            console.log(error);
        }
    }

    const setUrl = (url: string) => {
        let url2 = url;
        if(url.includes("googleapis")) {
            url2 = `/google-storage/${encodeURIComponent(url)}`
        }
        return url2;
    }

    return (
        <div style={{
            width: "700px",
            display: "flex",
            height: "100vh",
            justifyContent: "center",
            flexDirection: "column",
            position: "relative",
        }}>
            <img src={`/google-storage/${encodeURIComponent(campaign.CampaignImageURL)}`} style={{
                            width: "100%",
                            height: "100vh",
                            position: "absolute",
                        }} />

            <div style={{
                display: "flex",
                maxWidth: "700px",
                maxHeight: "65vh",
                flex: "1",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
                zIndex: 1,
            }}>
              {/*   <h2 style={{textAlign: "center", color: "white"}}>{campaign.CampaignName}</h2> */}
                
                
                {
                    loading ? <Loading/> :  <div style={{
                        width: "100%",
                        overflow: "auto",
                        textAlign: "center",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center"
                    }}>
                        {
                            audioList.map((a) => (
                                <AudioPlayer
                                    key={a.id}
                                    style={{
                                        maxWidth: "90%",
                                        borderRadius: "20px",
                                        margin: "7px"
                                    }}
                                    src={setUrl(a.src_audio)}
                                    loop={false}
                                    progressJumpSteps={{
                                        forward: forward_audio_podcast * 1000,
                                        backward: forward_audio_podcast * 1000,
                                    }}
                                    layout="horizontal-reverse"
                                    customControlsSection={[
                                        RHAP_UI.MAIN_CONTROLS
                                    ]}
                                    
                                    //showJumpControls={false} condicional despues de tantos segundos mostralos
                                    header={<><span>{a.title_audio}</span></>}
                                    onPlay={(e) => {
                                        if(!playList.includes(a)) {
                                            setPlayList([...playList, a])
                                            postPlayAudio(a);
                                        }
                                        if(!firstPlay && !start_counter) {
                                            setFirstPlay(true);
                                            initiCounter();
                                        } 
                                        setPlaying({id: a.id, play: true, src_audio: a.src_audio})
                                    }}
                                    onListen={(e) => {
                                        if(e.type === "timeupdate") {
                                            let podcast = analyticsAudio.find(v => v.podcast_id === a.id);
                                            if(podcast) {
                                                podcast = {
                                                    ...podcast,
                                                    duration: Math.floor(e.target.currentTime)
                                                }
                                                let ils = analyticsAudio.map(v => {
                                                    if (v.podcast_id == podcast.podcast_id) {
                                                        return podcast;
                                                    }
                                                    return v;
                                                });
                                                setAnalyticsAudio(ils)
                                               
                                            } else {
                                                setAnalyticsAudio([...analyticsAudio, {
                                                    podcast_id: a.id,
                                                    duration: Math.floor(e.target.currentTime),
                                                    deviceid: DeviceID.replace(/:/g, ""),
                                                    ap_mac: ap.ap_mac,
                                                    date_play: new Date()
                                                }]);
                                            }
                                        }
                                    }}
                                />
    
                        ))
                        }
                    </div>
                }
            
            </div>
                <div style={{
                    background: "linear-gradient(to bottom, transparent 0%, black 100%)",
                    position: "absolute",
                    color: "white",
                    maxWidth: "700px",
                    bottom: 0,
                    display: "flex",
                    width: "100%",
                    justifyContent: "center",
                }}>
                    <div className="row w-100 p-3">
                        <div className="col-6">
                            <button type="button" disabled={loading } className="btn btn-lg w-100" onClick={() => _goBack()} style={{backgroundColor: "white", color: "black"}}>Regresar</button>
                        </div>
                        <div className="col-6">
                            <button type="button" disabled={loading || (counter > 1)} className="btn btn-lg w-100" onClick={() => _postImpression()} style={{backgroundColor: "white", color: "black"}}>Wifi</button>
                        </div>
                    </div>
                </div>
                    
                )

        </div>
    )
}